<div class="container mx-auto md:text-base text-sm">
  <div class="mt-8 text-center">
    <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl">{{ "fallback" | translate }}</h1>
  </div>
  <div class="flex">
    <img src="assets/ACP-Error-bot_warning.webp" alt="Image of a sad face" class="mx-auto w-full sm:w-1/2" />
  </div>
</div>
